import * as config from "@/config";

export default ({ app }, inject) => {
  inject("appConfig", config);
};
